import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import ButtonWithMargin from "./ButtonWithMargin";
import {useTranslation} from "react-i18next";

interface AddButtonProps {
  onClick: () => void
  disabled?: boolean;
}

export default function AddButton({onClick, disabled}: Readonly<AddButtonProps>) {

  const {t} = useTranslation()

  return (
    <ButtonWithMargin
      variant="contained"
      startIcon={<AddIcon />}
      onClick={onClick}
      disabled={disabled}
    >
      {t('pages.addButton')}
    </ButtonWithMargin>
  )
}
